<template>
  <div>
    <el-card style="margin-top: 10px;">
      <el-descriptions title="当前登录信息" :column="2">
        <el-descriptions-item label="账户名">{{ userInfo.account }}</el-descriptions-item>
        <el-descriptions-item label="登录IP">{{ userInfo.loginIp }}</el-descriptions-item>
        <el-descriptions-item label="登录时间">{{ userInfo.loginTime }}</el-descriptions-item>
        <el-descriptions-item label="账号有效期">
          <el-tag size="small">{{ userInfo.expireDate }}</el-tag>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card style="margin-top: 30px;">
      <el-descriptions title="上次登录信息" :column="2">
        <el-descriptions-item label="登录城市">{{ loginInfo.city }}</el-descriptions-item>
        <el-descriptions-item label="登录IP">{{ loginInfo.ip }}</el-descriptions-item>
        <el-descriptions-item label="登录时间">{{ loginInfo.loginTime }}</el-descriptions-item>
        <el-descriptions-item label="登录状态">
          <el-tag size="small">{{ loginInfo.loginStatus }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="附加信息">{{ loginInfo.result }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import { post } from '../../../public/request/request.js'

export default {
  data() {
    return {
      userInfo: {},
      loginInfo: {}
    }
  },
  created() {
    const jsonStr = sessionStorage.getItem('loginInfo')
    if (jsonStr) this.userInfo = JSON.parse(jsonStr)
  },
  mounted() {
    this.huoQuDengLuXinXi()
  },
  methods: {
    huoQuDengLuXinXi() {
      const loading = this.openLoading()
      post(220, null)
        .then(response => {
          if (response.data.result == 0) {
            this.loginInfo = response.data.data
            loading.close()
          } else {
            this.$message.error('获取上次登录信息失败:' + response.data.message)
            loading.close()
          }
        })
        .catch(error => {
          this.$message.error((error && error.userMessage) || '获取上次登录信息失败')
          loading.close()
        })
    },
    openLoading() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      return loading
    }
  }
}
</script>
